// extracted by mini-css-extract-plugin
export default {"propsSection":"props-table-module--props-section--2YAxU","propsTable":"props-table-module--props-table--1HbCZ"};